import React from 'react';
import { Container } from '@hover/blueprint';
import AboutSectionsMobile from './AboutSectionsMobile';
import AboutSectionsDesktop from './AboutSectionsDesktop';

const AboutSections: React.FC = () => (
  <Container maxW="1200px" pt={600}>
    <AboutSectionsMobile />
    <AboutSectionsDesktop />
  </Container>
);

export default AboutSections;
